import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

function initTestimonialSlider() {
    const sliders = document.querySelectorAll('.testimonial-swiper');
    
    sliders.forEach(slider => {
        // Initialize Swiper
        const swiper = new Swiper(slider, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
        });

        // Get all slide-specific navigation elements
        const slideNavs = slider.querySelectorAll('.swiper-slide .slider-nav');
        
        slideNavs.forEach(nav => {
            const prevBtn = nav.querySelector('.slider-prev');
            const nextBtn = nav.querySelector('.slider-next');

            // Add click handlers for slide-specific navigation
            if (prevBtn) {
                prevBtn.addEventListener('click', () => {
                    swiper.slidePrev();
                });
            }

            if (nextBtn) {
                nextBtn.addEventListener('click', () => {
                    swiper.slideNext();
                });
            }
        });
    });
};

initTestimonialSlider();